module.exports = __webpack_public_path__ + "img/qiqiu.ae20e4e1.png";